import Vue from 'vue';
import Spinner from '@/app/spinner/spinner';

export default new Vue({
    el        : '#spinner',
    components: {Spinner},
    template  : '<spinner/>'
});
